import { GridContainerColClasses, GridContainerGapClasses } from '@constants/layout';
import { HeaderProps } from '@lib/types';
import cn from '@utils/cn';
import { isElementExistInHeader } from '@utils/validations';
import HeaderButtons from './components/HeaderButtons';
import HeaderText from './components/HeaderText';

export default function HeaderCenter(props: HeaderProps) {
  if (!isElementExistInHeader(props)) {
    return null;
  }

  return (
    <div className={cn('w-full items-center', GridContainerColClasses, GridContainerGapClasses, props.className)}>
      <div
        className={cn(
          'relative col-span-4 flex flex-col gap-8 text-center',
          'sm:col-span-6 md:col-span-8 lg:col-span-8 lg:col-start-3',
        )}
      >
        <HeaderText
          unicase={props.unicase}
          title={props.title}
          description={props.description}
          unicaseIsPill={props.unicaseIsPill}
          className={props.classNameText}
        />
        {props.children}
        <HeaderButtons
          buttonPrimary={props.buttonPrimary}
          buttonSecondary={props.buttonSecondary}
          buttonLink={props.buttonLink}
          embedButton={props.embedButton}
          className={cn('flex w-full flex-col justify-center gap-4 sm:flex-row', props.classNameButtons)}
        />
      </div>
    </div>
  );
}
